import React from "react";
import { Route, Routes , Navigate } from "react-router-dom";

import Navbar from "./Navbar";
import Home from "./Home";
import Services from "./Services";
import Products from "./Products";
import SignUp from "./SignUp";


function App() {
  return (
    <>
    <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default App;
